import type { DropdownMultiselectOptionProps } from './types'
import { Checkbox } from '@sunwebgroup/uds-ui/checkbox'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import styles from './CheckBoxWithExtra.module.css'
import { DropdownMultiselectContext } from './context'

interface CheckboxWithExtraProps extends DropdownMultiselectOptionProps {
  'description'?: string
  'count'?: number | string
  'supportingText'?: string
  'data-qa'?: string
}

function CheckboxWithExtra({ value, children, count, supportingText, ...rest }: CheckboxWithExtraProps) {
  const { selectedValues, removeOption, addOption } = React.use(DropdownMultiselectContext)

  const isSelected = selectedValues.includes(value)

  const handleCheckedChange = () => {
    if (isSelected) {
      removeOption(value)
      return
    }

    addOption(value)
  }

  return (
    <label className={styles.wrapper} {...rest}>
      <Checkbox className={styles.checkbox} checked={isSelected} onCheckedChange={handleCheckedChange} />
      <div className={cn(styles.textWrapper, Boolean(supportingText) && styles.textWrapperVertical)}>
        <Typography className={styles.label}>{children}</Typography>
        {count && <Typography variant="body-m-regular-tight">{count}</Typography>}
        {supportingText && (
          <Typography variant="body-s-regular-tight" className={cn(styles.label, styles.supportingText)}>
            {supportingText}
          </Typography>
        )}
      </div>
    </label>
  )
}

export function CheckboxWithCounterOption({ ...rest }: CheckboxWithExtraProps) {
  return <CheckboxWithExtra {...rest} />
}
export function CheckboxWithSupportingTextOption({ ...rest }: CheckboxWithExtraProps) {
  return <CheckboxWithExtra {...rest} />
}
